// src/components/student/StudentOrgBar.js
//
// Pass 85.1A.1 — the SHARED student org control, reused by every live student route (Home/Videos/Lessons/Progress) so
// the canonical participant/org context is presented identically everywhere. It shows the org selector ONLY when the
// Auth account is a participant in more than one org, surfaces the ambiguous state (two participants in one org — never
// guessed), and prompts a choice when needed. It renders nothing for a single-org modern account or a legacy account.

import React from 'react';

const font = "'DM Sans',system-ui,sans-serif";
const note = { fontFamily: font, background: '#FEF2F2', border: '1px solid #FECACA', color: '#B91C1C', borderRadius: 10, padding: '10px 14px', margin: '0 0 16px', fontSize: 13 };
const choose = { fontFamily: font, background: '#FFFBEB', border: '1px solid #FDE68A', color: '#92400E', borderRadius: 10, padding: '10px 14px', margin: '0 0 16px', fontSize: 13 };

export default function StudentOrgBar({ ctx }) {
  if (!ctx || !ctx.hasAnyParticipant) return null; // legacy account → no canonical org control
  return (
    <>
      {ctx.orgOptions.length > 1 && (
        <div data-testid="student-org-bar" style={{ display: 'flex', gap: 10, alignItems: 'center', margin: '0 0 16px', fontFamily: font }}>
          <span style={{ fontSize: 12.5, color: '#8A8980' }}>Organisation</span>
          <select
            data-testid="student-org-select"
            value={ctx.selectedOrganizationId}
            onChange={(e) => ctx.setSelectedOrganizationId(e.target.value)}
            style={{ padding: '7px 10px', borderRadius: 8, border: '1px solid rgba(0,0,0,0.12)', fontSize: 13, background: '#fff', fontFamily: font }}
          >
            <option value="">Choose your organisation…</option>
            {ctx.orgOptions.map((o) => <option key={o.organizationId} value={o.organizationId}>{o.displayName || o.organizationId}</option>)}
          </select>
        </div>
      )}
      {ctx.needsOrgChoice && (
        <div data-testid="student-choose-org" style={choose}>Choose an organisation above to see your coaching.</div>
      )}
      {ctx.ambiguous && (
        <div data-testid="student-ambiguous" style={note}>
          Your account is linked to more than one profile in this organisation. Please contact your coach to resolve which profile is yours — we won’t guess.
        </div>
      )}
    </>
  );
}
